import React, {ChangeEvent} from 'react';
import { lovLabel, lovValue } from 'core/form/formUtils';
import documentService from "core/document/documentService";
import Dropzone from 'react-dropzone';
import 'core/document/component/documentComp.less';
import { Document, DOCUMENTATTACHMENTTYPE, DocumentTemplateResource } from 'core/document/documentDomain';
import {ObservableMap, action} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {DomainAncestor} from "core/common/domain/DomainAncestor";
import {observer} from "mobx-react";
import uiService from "core/common/service/uiService";
import {abbreviate} from "core/common/utils/stringUtils";
import {grey400} from "material-ui/styles/colors";
import {Tooltip, OverlayTrigger} from "react-bootstrap";
import moment from "moment";
import mdEntityService from '../../metamodel/mdEntityService';
import { ZzIconButtonMenu } from '../../components/buttons/icons';
import MenuItem from 'material-ui/MenuItem';
import Add from 'material-ui/svg-icons/content/add';
import Remove from 'material-ui/svg-icons/content/remove-circle-outline';
import Attach from 'material-ui/svg-icons/editor/attach-file';
import ImportContacts from 'material-ui/svg-icons/communication/import-contacts';


interface DocumentCompProps {
  documents: Document[];
  entities: ObservableMap<MdEntity>;
  style?: any;
  enableUpload?: boolean;
  showIncludeCheckbox?: boolean;
  rootObject?: DomainAncestor;
  documentEntity: MdEntity;
  canDeleteFn?: (rootObject: DomainAncestor, document: Document) => boolean;
  showFilterFn?: (document: Document) => boolean;
  saveFn?: (documents: Document[]) => Promise<any>;
  deleteFn?: (document: Document) => Promise<any>;
  defaultAttachmentType?: DOCUMENTATTACHMENTTYPE;
}

interface DocumentCompState {
  $loading: boolean;
}


@observer
export default class DocumentComp extends React.Component<DocumentCompProps, DocumentCompState> {


  static defaultProps = {
    showFilterFn: (document) => (true),
    canDeleteFn: (rootObject, document) => (true)
  };


  state: DocumentCompState = {
    $loading: false
  };

  @action onDrop = (files) => {
    const {documents, rootObject, documentEntity, saveFn, defaultAttachmentType} = this.props;
    console.log('onDrop ', files);
    this.setState({$loading: true});
    uiService.showToolbarActionFlag();
    let promiseArray: Promise<DocumentTemplateResource>[] = files.map(file => documentService.loadFile(file));
    Promise.all(promiseArray).then(resultArray => {
      for (let resource of resultArray) {
        let newDoc = new Document({
          $new: true,
          name: resource.name,
          size: resource.size,
          contentType: resource.contentType,
          lastModified: resource.lastModified,
          documentType: null,
          data: resource.content,
          attachmentType: (lovValue(defaultAttachmentType) == DOCUMENTATTACHMENTTYPE.PDF_INCLUDE && resource.contentType !== "application/pdf") ? DOCUMENTATTACHMENTTYPE.SEPARATE_INCLUDE : defaultAttachmentType,
        } as any);
        documents.push(newDoc);
      }
      if (saveFn) {
        return saveFn(documents).then(res => {
          this.setState({$loading: false});
          uiService.hideToolbarActionFlag();
        });
      } else {
        rootObject.$dirty = true;
        this.setState({$loading: false});
        uiService.hideToolbarActionFlag();
      }
    }, err => {
      this.setState({$loading: false});
      uiService.hideToolbarActionFlag();
    });
  };


  @action onDelete = (document) => {
    let {documents, rootObject, deleteFn} = this.props;
    console.log('onDelete ', document);
    let deletedDocs: Document[] = documents.splice(documents.indexOf(document), 1);
    if (deleteFn && deletedDocs.length) {
      return deleteFn(deletedDocs[0]);
    } else {
      rootObject.$dirty = true;
    }
  };

  @action onClickCheckbox = (value: DOCUMENTATTACHMENTTYPE, doc: Document, evt: ChangeEvent<HTMLInputElement>) => {
    let {rootObject} = this.props;
    console.log("onClickCheckbox, %s", value);
    let DOCUMENTATTACHMENTTYPE = mdEntityService.getEntity('DOCUMENTATTACHMENTTYPE')
    doc.attachmentType = DOCUMENTATTACHMENTTYPE.getLovItem(value)
    rootObject.$dirty = true;
    doc.$dirty = true;
  }

  @action onPrint = (doc: Document) => {
    console.log('onPrint', doc);
    documentService.printDocument(doc.documentUuid);
  };



  render() {
    const {documents, rootObject, style, enableUpload, canDeleteFn, showFilterFn, showIncludeCheckbox} = this.props;

    let DOCUMENTATTACHMENTTYPEEntity = mdEntityService.getEntity('DOCUMENTATTACHMENTTYPE')

    return (
      <div style={Object.assign({display: 'flex'}, style)}>


        { (documents) ?
          documents.filter((doc, index) => showFilterFn(doc))
            .sort((doc1, doc2) => (moment(doc1.dateCreated)).valueOf() - (moment(doc2.dateCreated)).valueOf())
            .map((doc, index) =>  (
            <div key={doc.documentId} className="document-block">
              <div className="document-block-header">{ abbreviate( (documentService.isUploadType(doc)) ? doc.name : lovLabel(doc.documentType), 18) }</div>
              <div className="document-block-icons">
                {(doc.documentId) ? (
                  <a href={documentService.documentUrl(doc.documentUuid, {inline:true})} target="_blank">
                    <span  className={'fa fa-' + doc.icon}/>
                  </a>
                ) : null}
                {(doc.documentId) ? (
                  <a href={documentService.documentUrl(doc.documentUuid, {})}>
                    <span  className={'fa fa-download'}/>
                  </a>
                ) : null}
                {(canDeleteFn(rootObject, doc)) ? (
                  <a className="document-block-icon-delete" onClick={this.onDelete.bind(this, doc)}>
                    <span className="fa fa-trash"/>
                  </a>
                ) : null}
              </div>
              <div className="document-block-icons">
                {(!doc.documentType && doc.documentId && showIncludeCheckbox) ? (
                  <OverlayTrigger placement="top"
                                  overlay={<Tooltip id="includeAttachmentTooltip" style={{fontSize: 13}}>How to include attachment in email or Invoice PDF</Tooltip>}>
                    <div style={{ width: 17, display: "flex", alignItems: "center", justifyContent: "center" }}>

                      <ZzIconButtonMenu buttonIcon={
                        (lovValue(doc.attachmentType) === DOCUMENTATTACHMENTTYPE.SEPARATE_INCLUDE) ? <Attach color="#3F51B5"/> :
                          ( (lovValue(doc.attachmentType) === DOCUMENTATTACHMENTTYPE.PDF_INCLUDE) ? <ImportContacts color="#3F51B5"/> :
                            ( (lovValue(doc.attachmentType) === DOCUMENTATTACHMENTTYPE.NO_INCLUDE) ? <Remove color="#3F51B5"/> : <Add color="#3F51B5"/> )
                          )
                      } >
                        {DOCUMENTATTACHMENTTYPEEntity.lovItems.filter(lv => lv.value != DOCUMENTATTACHMENTTYPE.PDF_INCLUDE || doc.contentType === "application/pdf").map( (lovItem, index) => <MenuItem primaryText={lovItem.label} key={index} onClick={this.onClickCheckbox.bind(this, lovItem.value, doc)}/> )}
                      </ZzIconButtonMenu>

                    </div>

                  </OverlayTrigger>
                ) : null}
                {(doc.documentId) ? (
                  <a onClick={this.onPrint.bind(this, doc)}>
                    <span className="fa fa-print"/>
                  </a>
                ) : null}
              </div>
            </div>
          )) : null
        }

        {(enableUpload) ? (
          <div>
            <Dropzone onDrop={this.onDrop}
                      style={{width: 100, height: 120, border: '2px dashed ' + grey400, color: grey400, fontSize: 12, display: "flex", alignItems: "center"}}>
              <div style={{textAlign: 'center'}}>Drop some files here, or click to select files to upload.</div>
            </Dropzone>
          </div>
        ) : null}

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/document/component/documentComp.tsx